export default __webpack_public_path__ + "static/important-travel-16280b88bcd1f32d7608cff2ebb5b84e.webp";